import React from "react";
import { PropTypes } from "prop-types";
import { MrbModal } from "mrb/components/modal";
import { observer } from "mobx-react";
import { CoverImageUpload } from "common/components";

// Small modal that hosts the shared cover-image uploader for a staged artist/album/track artwork.
// The uploader writes the new MediaVault file-entry id back into the staged tree via its onChange;
// closing the modal keeps whatever was uploaded.
//
// `shouldFocusAfterRender={false}` is important here: react-modal otherwise traps/steals focus, which
// prevents react-dropzone's programmatic `open()` (the "Upload image" button) from opening the native
// file picker in some browsers. Clicking the drop area works regardless, but this makes the button work too.
const NakiNigunImportArtworkUploadModalTemplate = observer(function NakiNigunImportArtworkUploadModalTemplate({
    modalParams,
    t,
}) {
    return (
        <MrbModal
            modalParams={modalParams}
            t={t}
            className="modal__content modal__content--med"
            shouldCloseOnOverlayClick={false}
            shouldFocusAfterRender={false}
            shouldReturnFocusAfterClose={false}
        >
            {() =>
                modalParams.data && modalParams.data.artworkUploadViewStore ? (
                    <div className="u-padd--md">
                        {modalParams.data.title && (
                            <p className="u-type--base u-type--wgt--semibold u-mar--bottom--med">
                                {modalParams.data.title}
                            </p>
                        )}
                        <CoverImageUpload
                            classNameExtendUpload="c-upload--tny"
                            coverImageUploadViewStore={modalParams.data.artworkUploadViewStore}
                            isFullWidthFooterButtons
                            showInfo
                        />
                        <div className="u-separator--primary u-mar--top--med u-mar--bottom--med"></div>
                        <div className="u-display--flex u-display--flex--jc--flex-end">
                            <button className="c-btn c-btn--base c-btn--primary" onClick={modalParams.close}>
                                {t("ADMINISTRATION.NAKI_NIGUN_IMPORT.EDIT.BUTTONS.DONE")}
                            </button>
                        </div>
                    </div>
                ) : null
            }
        </MrbModal>
    );
});

NakiNigunImportArtworkUploadModalTemplate.propTypes = {
    modalParams: PropTypes.object.isRequired,
    t: PropTypes.func,
};

export default NakiNigunImportArtworkUploadModalTemplate;
